export default {
  data() {
    return {
      suggestedTypes: []
    }
  },

  mounted() {
    this.suggestedTypes = [
      {
        pageNames: 'home',
        widgets: ['slideshow', 'feature-blocks', 'text-image']
      },
      {
        pageNames: 'services packages plans offers',
        widgets: ['slideshow', 'text-content', 'text-image', 'pricing-table', 'tabs', 'accordion']
      },
      {
        pageNames: 'about us who we are meet the team',
        widgets: ['slideshow', 'text-content', 'text-image', 'team-members', 'mini-carousel', 'tabs']
      },
      {
        pageNames: 'reviews testimonials testimonies recommendations endorsements',
        widgets: ['slideshow', 'reviews', 'simple-form']
      },
      {
        pageNames: 'gallery work photos',
        widgets: ['slideshow', 'basic-gallery', 'mini-carousel']
      },
      {
        pageNames: 'contact us quote help support',
        widgets: ['slideshow', 'simple-form', 'landing-form', 'accordion', 'tabs', 'text-content']
      },
      {
        pageNames: 'product list products items range',
        widgets: ['slideshow', 'product-list', 'reviews']
      },
      {
        pageNames: 'lead page landing page',
        widgets: ['slideshow', 'landing-form', 'simple-form', 'reviews', 'mini-carousel', 'basic-gallery']
      }
    ]

    this.suggestedTypesLoaded = true
  }
}
